<div style="height: 100%; width: 100%;">

  <div fxLayout=row style="height: 100%;">

    <div fxFlex=38 fxHide.lt-md>
      <img class="image1" src="../../../../assets/images/login1.png">
    </div>

    <div fxFlex=62 fxFlex.lt-md=100>
      <img class="image2" ngClass.lt-md="image2-full" src="../../../../assets/images/login2.png">

      <div fxLayout="column" fxLayoutAlign="center center" style="height: 100%;">

        <div fxLayout="row wrap" style="width: 50%;">

          <div fxFlex=100>
            <mat-divider></mat-divider>
          </div>

          <div fxFlex=100 fxLayoutAlign="center center">
            <h1 id=welcome>BENVENUTO</h1>
          </div>

          <div fxFlex=100>
            <mat-divider></mat-divider>
          </div>


<!--        <div fxFlex=100 class=form-container>-->
<!--          <form [formGroup]=loginForm>-->

<!--            <div>-->
<!--              <span class="descr">Username</span>-->
<!--              <mat-form-field appearance="outline" style="width: 100%;">-->
<!--                <input matInput formControlName="username">-->
<!--              </mat-form-field>-->
<!--            </div>-->

<!--            <div>-->
<!--              <span class="descr">Password</span>-->
<!--              <mat-form-field appearance="outline" style="width: 100%;">-->
<!--                <input matInput [type]="hidePsw ? 'password' : 'text'">-->
<!--                <button mat-icon-button matSuffix (click)="hidePsw = !hidePsw">-->
<!--                  <mat-icon>{{hidePsw ? 'visibility_off' : 'visibility'}}</mat-icon>-->
<!--                </button>-->
<!--              </mat-form-field>-->

<!--            </div>-->

<!--          </form>-->
<!--        </div>-->

<!--        <div fxFlex=100 fxLayoutAlign=center>-->
<!--          <button mat-raised-button color=warn (click)="onLogin()"><mat-icon>home</mat-icon>LOGIN</button>-->
<!--        </div>-->


      </div>

      </div>

    </div>

  </div>

</div>
